import axios from "axios"; //ajax封装
import cacheUtils from '@/common/cacheUtils'; //调用缓存
import { Loading } from 'element-ui';
const Bearer = 'Bearer'; //token 前面必须要增加此参数
// Loading.service({
//   fullscreen: true
// })

const TIMEOUT = 300000000,
  xhr = axios.create({
    baseURL: process.env.VUE_APP_REQUEST_URL,
    timeout: TIMEOUT,
    withCredentials: true,
    validateStatus(status) {
      return status >= 200 && status < 500; // default
    },
  });
  
// 添加请求拦截器
xhr.interceptors.request.use(
  config => {
   config.headers.common['Authorization'] = cacheUtils.cookie.getObject('Token') ?  Bearer +
      cacheUtils.cookie.getObject('Token') : '';
    return config
  },
  // 请求错误时做些事
  error => Promise.reject(error)
);

// 添加响应拦截器
xhr.interceptors.response.use(
  response => {
    if (+response.data.status_code === 200) {
      // loadingInstance.close();
      return response.data;
    }
    return Promise.reject(response.data);
  },
  error => Promise.reject(error)
);

export default xhr;
